import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { LiveSearchMetadataGridViewDataProvider } from '../dataProvider/LiveSearchMetadataGridViewDataProvider';

export class LiveSearchMetadataGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();

    this.map.set(API_TYPE_GZ, LiveSearchMetadataGridViewDataProvider);
  }
}
